import React, { useEffect } from "react";
import Profile from "./Profile.container";
import Services from "./Services/container";
import Feedback from "./Feedback/container";
import Aside from "./Aside/container";
import { ServicesAndSidebarContainer } from "./styled";
import { Row, Col } from "reactstrap";
import Portfolio from "./Portfolio.container";
import FreeSlotsModal from "./FreeSlotsModal/container";
import SEO from "./Seo.container";
import { useTranslation } from "react-i18next";
import PT from "prop-types";
import { useExtractHL } from "@/hooks/useExtractHL";
import { FullScreenSpin as Spin } from "_c/preloader";
import OnboardingModal from "_c/Modals/onboarding";
import { useAllSpecsQuery } from "@/hooks/queries/useAllSpecsQuery";
import QueryRequest from "_c/QueryRequest";
import SimilarMasters from "./SimilarMasters";

const MasterPage = (props) => {
  const { t, ready } = useTranslation(["common", "errors", "master_profile"], {
    useSuspense: false,
  });
  const specsQuery = useAllSpecsQuery();
  const hl = useExtractHL();
  const spin = <Spin size="xl" />;
  useEffect(() => {
    if (props.isAuth) {
      props.addToClientHistory();
    }
  }, [props.isAuth]);
  if (!ready || !props.profile) return spin;
  return (
    <QueryRequest spin={spin} query={specsQuery}>
      <SEO specs={specsQuery.data} t={t} />
      <Profile hl={hl} pageType="master" />
      <Portfolio type="master" />
      <ServicesAndSidebarContainer>
        <Row>
          <Col lg="8">
            <Services specs={specsQuery.data} t={t} />
            <Feedback t={t} />
          </Col>
          <Col lg="4">
            <Aside hl={hl} t={t} />
          </Col>
        </Row>
        {!props.isOwner && (
          <Row>
            <Col>
              <SimilarMasters t={t} />
            </Col>
          </Row>
        )}
      </ServicesAndSidebarContainer>
      <FreeSlotsModal t={t} />
      {props.isOwner && <OnboardingModal domain="profile" />}
    </QueryRequest>
  );
};
MasterPage.propTypes = {
  isAuth: PT.bool,
  profile: PT.any,
  isOwner: PT.bool,

  addToClientHistory: PT.func.isRequired,
};

export default MasterPage;
